import { convert_date_to_timestamp, is_in_timerange, get_last_day_of_month, get_last_day_of_year } from './dates'


export function filter(activeFilters, activeFilter, results) {

  if (activeFilter.type == "date" && activeFilter.position != "top") {
    //date picker


    if (!activeFilter.value[0])
      return results;

    let start_date = convert_date_to_timestamp(activeFilter.value[0]);
    let end_date = false;

    if (activeFilter.value[1]) {
      end_date = convert_date_to_timestamp(activeFilter.value[1]);
    }

    results = results.filter(function (res) {

      let has_performances = false;

      if (typeof res.performance_dates == 'undefined' || !res.performance_dates.length) {
        if (!res.start_date) {
          return false;
        }

        let item_start_date = parseInt(res.start_date),
          item_end_date = parseInt(res.end_date);


        if (end_date) {
          if (item_start_date <= (end_date + (24 * 60 * 60)) && item_end_date >= start_date) {
            has_performances = true;
          }
        } else {
          if (item_start_date <= start_date && item_end_date >= start_date) {
            has_performances = true;
          }
        }
      } else {
        res.performance_dates.forEach(function (performance_date) {
          if (end_date) {
            if (performance_date >= start_date && performance_date <= end_date) {
              has_performances = true;
            }
          } else {

            if (performance_date >= start_date) {
              has_performances = true;
            }
          }

        });
      }




      return has_performances;


    })
    // results = results.filter(function(res){
    //   console.log(res, 'res')

    //   if (typeof res.performance_dates == 'undefined' || !res.performance_dates.length)
    //     return false;

    //   let has_performances = false;

    //   res.performance_dates.forEach(function(performance_date){
    //     if (end_date ){
    //       if ( performance_date >=  start_date && performance_date <=  end_date){
    //         has_performances = true;
    //       }
    //     } else {

    //       if ( performance_date >=  start_date){
    //         has_performances = true;
    //       }
    //     }

    //   });

    //   return has_performances;


    // })

  }

  if (activeFilter.type == "date" && activeFilter.position == "top") {
    if (activeFilter.name == "auto") {

      if (!activeFilter.value.toString().length || activeFilter.value == "all")
        return results;


      results = results.filter(function (res) {
        if (typeof res.performance_dates == 'undefined' || !res.performance_dates.length)
          return false;

        let has_performances = false;

        res.performance_dates.forEach(function (performance_date) {

          if (!isNaN(activeFilter.value) && typeof activeFilter.value == "number") {
            if (performance_date == activeFilter.value) {
              has_performances = true;
            }
          } else {
            has_performances = false;
          }
        });

        return has_performances;
      })
    }

    if (activeFilter.name == "daily") {

      if (!activeFilter.value.toString().length || activeFilter.value == "all")
        return results;


      results = results.filter(function (res) {
        if (typeof res.performance_dates == 'undefined' || !res.performance_dates.length)
          return false;

        let has_performances = false;

        res.performance_dates.forEach(function (performance_date) {
          if (!isNaN(activeFilter.value) && typeof activeFilter.value == "number") {
            if (performance_date == activeFilter.value) {
              has_performances = true;
            }
          } else {
            has_performances = false;
          }
        });

        return has_performances;
      })
    }

    if (activeFilter.name == "weekly") {

      if (!activeFilter.value.toString().length || activeFilter.value == "all")
        return results;


      results = results.filter(function (res) {
        if (typeof res.performance_dates == 'undefined' || !res.performance_dates.length)
          return false;

        let has_performances = false;

        res.performance_dates.forEach(function (performance_date) {

          if (!isNaN(activeFilter.value) && typeof activeFilter.value == "number") {
            if (performance_date >= activeFilter.value && performance_date <= activeFilter.value + (6 * 24 * 60 * 60)) {
              has_performances = true;
            }
          } else {
            has_performances = false;
          }
        });

        return has_performances;
      })
    }

    if (activeFilter.name == "monthly") {

      if (!activeFilter.value.toString().length || activeFilter.value == "all")
        return results;


      results = results.filter(function (res) {
        if (typeof res.performance_dates == 'undefined' || !res.performance_dates.length)
          return false;

        let has_performances = false;

        res.performance_dates.forEach(function (performance_date) {
          if (!isNaN(activeFilter.value) && typeof activeFilter.value == "number") {
            if (performance_date >= activeFilter.value && performance_date <= get_last_day_of_month(activeFilter.value)) {
              has_performances = true;
            }
          } else {
            has_performances = false;
          }
        });

        return has_performances;
      })
    }

    if (activeFilter.name == "yearly") {

      if (!activeFilter.value.toString().length || activeFilter.value == "all")
        return results;


      results = results.filter(function (res) {
        if (typeof res.performance_dates == 'undefined' || !res.performance_dates.length)
          return false;

        let has_performances = false;

        res.performance_dates.forEach(function (performance_date) {
          if (!isNaN(activeFilter.value) && typeof activeFilter.value == "number") {
            if (performance_date >= activeFilter.value && performance_date <= get_last_day_of_year(activeFilter.value)) {
              has_performances = true;
            }
          } else {
            has_performances = false;
          }
        });

        return has_performances;
      })
    }

  } else if (activeFilter.type == "tag" && activeFilter.position == "top") {

    if (!activeFilter.value.toString().length || activeFilter.value == "all")
      return results;

    let active_parent_tag = "";
    activeFilter.options.forEach((option) => {
      if (option.value == activeFilter.value) {
        active_parent_tag = option.parent
      }
    });

    results = results.filter(function (res) {
      if (typeof res[active_parent_tag] !== "undefined" && res[active_parent_tag].indexOf(activeFilter.value) > -1) {
        return true;
      }
      return false;
    });

  }

  if (activeFilter.type == "hidden" && activeFilter.name == "search" && activeFilter.value.length) {
    results = results.filter(result => {
      if (typeof (result.search) != "undefined") {
        return result.search.toLowerCase().indexOf(activeFilters.search.value.toLowerCase()) > -1 || !activeFilters.search.value.length
      }
      return false;
    });

  }
  // if (activeFilter.type == "search" && activeFilter.value.length){

  //   results = results.filter(result => {
  //     if (typeof(result.search) != "undefined"){
  //       return result.search.toLowerCase().indexOf(activeFilters.search.value.toLowerCase()) > -1 || !activeFilters.search.value.length
  //     }
  //     return false;
  //   });

  // }

  if (activeFilter.type === "search" && activeFilter.value.length) {

    const searchTerms = activeFilters.search.value
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .filter(term => term.length >= 3);

    results = results.filter(result => {
      if (typeof result.search !== "undefined") {
        const searchData = result.search.toLowerCase();

        return (
          !searchTerms.length ||
          searchTerms.some(term => searchData.includes(term))
        );
      }

      return false;
    });

  }

  if (activeFilter.type == "checkbox" && activeFilter.value.length) {

    results = results.filter(result => {





      //   if (typeof result[activeFilter.name] == "undefined" || !result[activeFilter.name].length)
      //     return false;

      //   return activeFilter.value.some(x => result[activeFilter.name].includes(x))

      // }
      if (typeof result[activeFilter.name] == "undefined" || !result[activeFilter.name].length)
        return false;

      const res = result[activeFilter.name].map(f => f.toString())
      // return activeFilter.value.some(x => res.includes(x))
      // let is_visible = activeFilter.value.some(x => res.includes(x));



      return activeFilter.value.some(x => res.includes(x.toString()))


    });


  }

  return results;
}

export function filter_items_venues(results, activeFilters, filterView, selectedMarkers) {

  if (selectedMarkers.length && filterView == "map") {
    results = results.filter(function (res) {

      let visible = false;

      if (filter_block == "Events") {
        if (res.event_venues == "") {
          return false;
        }
        const venues = res.event_venues;
        for (const key in venues) {
          let venue_hash = key;

          selectedMarkers.forEach((selectedMarker) => {
            if (venue_hash == selectedMarker.id) {
              visible = true;
            }
          })

        }
      } else {
        selectedMarkers.forEach((selectedMarker) => {
          if (res.name == selectedMarker.title) {
            visible = true;
          }
        })
      }


      return visible;
    })
  }
  return results;
}


export function filter_items(results, activeFilters, filterView, selectedMarkers) {




  let res = results;
  let and_count = 0;

  for (const key in activeFilters) {

    if (activeFilters.hasOwnProperty(key)) {
      const activeFilter = activeFilters[key];
      and_count++;
      res = filter(activeFilters, activeFilter, res);

    }
  }
  let final_results = res;
  let or_results = [];
  let or_count = 0;




  for (const key in activeFilters) {

    if (activeFilters.hasOwnProperty(key)) {

      const activeFilter = activeFilters[key];

      if (activeFilter.or && activeFilter.value.length) {
        or_count++;

        let or_result = filter(activeFilters, activeFilter, final_results);

        if (or_count > 0) {
          or_results = [...new Set([...or_results, ...or_result])];
        } else {
          or_results = or_result;
        }

        final_results = or_results;
      }

    }
  }


  return final_results;
}
